export type TimeField = 'hours' | 'minutes' | 'seconds';

export type TimeInputSize = 'small' | 'large';
export type TimeInputVariant = 'default' | 'primary';

export const TIME_DURATION_FIELD = {
  HOURS: 'hours',
  MINUTES: 'minutes',
  SECONDS: 'seconds'
} as const satisfies Record<string, TimeField>;

export const TIME_INPUT_SIZE = {
  SMALL: 'small',
  LARGE: 'large'
} as const satisfies Record<string, TimeInputSize>;

export const TIME_INPUT_VARIANT = {
  DEFAULT: 'default',
  PRIMARY: 'primary'
} as const satisfies Record<string, TimeInputVariant>;

/** Clock-style field caps (hours:minutes:seconds of a day). */
export const CLOCK_TIME_FIELD_MAX = {
  HOURS: 23,
  MINUTES: 60,
  SECONDS: 60
} as const;

export const DEFAULT_TIME_INPUT_MAX_LENGTH = 2;

/** Intl.DurationFormat options for compact locale-aware labels (e.g. 1h 30m). */
const LOCALIZED_DURATION_STYLE = {
  LONG: 'long',
  SHORT: 'short',
  NARROW: 'narrow',
  DIGITAL: 'digital'
} as const;

export const LOCALIZED_DURATION_FORMAT = {
  STYLE: LOCALIZED_DURATION_STYLE,
  DEFAULT: {
    style: LOCALIZED_DURATION_STYLE.NARROW
  }
} as const;
